<template>
  <b-modal ref="modal" v-bind="{...$props, ...$attrs}" v-on="$listeners">
    <template #modal-header>
      <slot name="modal-header"></slot>
    </template>
    <template #modal-footer>
      <slot name="modal-footer"></slot>
    </template>
    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  props: {
    anchor: [Array, String]
  },
  mounted(){
    if(this.shouldShow(this.$route.hash)){
      this.$refs.modal.show()
    }
  },
  methods: {
    shouldShow: function(hash) {
      if (Array.isArray(this.anchor)) {
        return this.anchor.length && this.anchor.includes(hash);
      }
      else if (typeof this.anchor == "string") {
        return this.anchor && hash == this.anchor;
      }
      else {
        return false;
      }
    }
  },
  watch: {
    $route: function(newVal, _oldVal) {
      if (this.shouldShow(newVal.hash)) {
        if (this.$store.state.openModal) return; // avoid more than one modal open at the time
        this.$refs.modal.show();
        this.$store.commit("setOpenModal", true)
      } else { this.$store.commit("setOpenModal", false) }
    }
  }
}
</script>
